import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const inTableTextInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("in-table-text").default("in-table-text"),
      text: z.string().default("")
    }),
    shouldValidate: node => !!node.validation.correctAnswers.length,
    validate: (node, entry, context) => {
      const isCorrect = node.validation.correctAnswers.some(answer => cleanText(answer, node.validation) === cleanText(entry.text, node.validation));
      if (!isCorrect) {
        return false;
      }

      //
      // NB: In case the current node is part of an answerGroup, then we must
      // ensure that repeats of the same answer is used across entries.
      //
      if (node.validation.answerGroupId) {
        const contestants = context.inputs.filter(it => {
          const entry = inTableTextInput.entry.asTypeSafe(it.entry);
          if (!entry) {
            return false;
          }
          return it.node.id !== node.id && it.node.nodeType === "in-table-text-input" && it.node.validation.answerGroupId === node.validation.answerGroupId;
        });
        const conflictingEntries = contestants.filter(contenstant => cleanText(entry.text, node.validation) === cleanText(contenstant.entry.text, node.validation));
        if (conflictingEntries.length) {
          const lowestConflictingIndex = Math.min(...conflictingEntries.map(it => it.node.index));
          const isFirstInput = lowestConflictingIndex > node.index;
          return isFirstInput;
        }
      }
      return isCorrect;
    },
    parseLegacyDetailItem: (item, context) => {
      if (["WriteAnswers"].includes(context.relatedTask.taskType) && ["InTable"].includes(context.relatedTask.answerType ?? "") && typeof item === "string") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "in-table-text",
          text: item
        }];
      }
    }
  },
  schema: z.object({
    type: z.literal("Writeable"),
    correctAnswerGroup: z.string().nullish().default(null),
    correctAnswer: z.array(z.string()).nullish().default(null),
    caseSensitive: z.boolean().nullish().default(false),
    ignoreWhitespace: z.boolean().nullish().default(false),
    style: z.object({
      align: z.enum(["Left", "Center", "Right"]).default("Center"),
      bold: z.boolean().default(false),
      italic: z.boolean().default(false)
    }).default({
      align: "Center",
      bold: false,
      italic: false
    })
  }),
  postprocessSchemaInput: (input, context) => {
    return {
      id: `${context.taskId}-${context.rowIndex}-${context.index}`,
      index: context.index,
      nodeType: "in-table-text-input",
      style: input.style,
      meta: {
        rowIndex: context.rowIndex
      },
      validation: {
        caseSensitive: input.caseSensitive,
        ignoreWhitespace: input.ignoreWhitespace,
        answerGroupId: input.correctAnswerGroup ? `${context.taskId}-${input.correctAnswerGroup}` : null,
        correctAnswers: input.correctAnswerGroup ? context.answerGroups[input.correctAnswerGroup] : input.correctAnswer
      }
    };
  },
  cleanText
});
function cleanText(text, options) {
  // Normalize whitespace
  if (!options.ignoreWhitespace) {
    text = String(text).replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ");
  } else {
    text = String(text).replace(/\s/g, "");
  }

  // Make canse insensitive?
  if (!options.caseSensitive) {
    text = text.toLowerCase();
  }

  // To make sure that validate accepts all variants of apostrophes
  // See https://dev.azure.com/gyldendaldenmark/GU-Produkter/_workitems/edit/93957
  text = text.replace(/[’‛‘´`′‵]/, "'");
  return text;
}

export { inTableTextInput };
//# sourceMappingURL=input.text.js.map
